import { Map } from 'immutable';

import { createController } from '../utils/controller';
import { EMPTY } from '../constants';

import studioPhoto from './studio.photo';
import studioVideo from './studio.video';
import actions from '../actions';

const imagesController = createController();
const foldersController = createController();

function abort(controller) {
  if (controller.isActive()) {
    controller.stop();
  }
}

function abortAll() {
  [
    imagesController,
    foldersController,
  ].forEach(abort);
}

function* bootstrap(reduction, { channel, db, shopId }) {
  abortAll();

  const state = Map({ channel, db, shopId });

  return reduction.set('studio', state);
}

function* cleanUp(reduction) {
  abortAll();

  const state = EMPTY.MAP;

  return reduction.set('studio', state);
}

const studio = {
  [actions.studio.bootstrap]: bootstrap,
  [actions.studio.cleanUp]: cleanUp,
  ...studioPhoto,
  ...studioVideo,
};

export default studio;
